module.exports = __webpack_public_path__ + "img/myServeItem-icon1.f1cd465e.jpg";